export const translations = {
  peopleAlsoAsk: {
    'fr': 'Autres questions posées (FAQs):',
    'de': 'Häufig gestellte Fragen (FAQs):',
    'ru': 'Часто задаваемые вопросы',
    'nl': 'Veelgestelde vragen (FAQ’s)',
    'en': 'Frequently asked questions',
    'fi': 'Usein kysyttyjä kysymyksiä',
    'es': 'Preguntas frecuentes',
    'sv': 'Vanliga frågor och svar (FAQ)',
    'hu': 'Gyakran ismételt kérdések',
    'he': 'שאלות נפוצות'
  },
  seeMore: {
    'fr': 'Voir plus...',
    'de': 'Lesen Sie weiter',
    'ru': 'Узнайте больше',
    'nl': 'Lees meer',
    'en': 'Learn more',
    'fi': 'Lue lisää',
    'sv': 'Läs mer',
    'he': 'למד עוד'
  },
  viewAll: {
    'fr': 'Afficher tout',
    'de': 'Alle ansehen',
    'ru': 'посмотреть все',
    'nl': 'Bekijk alles',
    'en': 'View all',
  }
};
